import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from "prop-types";
import {
    VertTypography,

    Row,
    Col,
    VertInput,
    VertButton,
    VertSelect,
    VertCheckbox,
    VertAlert,
    Form
} from "@vertem-core/vertice-ds";
import MediaQuery, { useMediaQuery } from "react-responsive";
import { debounce } from 'lodash';
import { handleObjectAddress } from "../../../Utils/handleObjectAddress";
import { listUF } from "../../Forms/FormsDeliveryAddressPersonal";
import MaskedInput from "../../../pages/newSolicitation/components/InputMask";
import SpotltmClient from "../../../Services/Apis/Spot/ltmApiService";
import moment from "moment/moment";
import { genderTypes, profileStatuses } from "../../../pages/profilePage/models";
import generateUUID from "../../../Utils/generateUUID";
import usePipeContext from "../../../Services/Providers/PipeProvider/usePipeContext";
import { getOnlyNumbers } from "../../../pages/profilePage";
import { CloseOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from 'react-redux';

import { closeModal as closeBalloon, closeModal } from 'redux/Reducers/PopBallon/VertemGiftSlice';
import { usePlaceholderLoading } from "components/PlaceholderLoading";
import { useLocation } from "react-router";
import { ValidateIe } from "../../../redux/Reducers/StateInscription/StateInscriptionReducer";
import ynToBool from 'Utils/ynToBool';




const inputFormDataDefault = {
    value: undefined,
    disabled: undefined
}

const initFormAddress = {
    name: inputFormDataDefault,
    street: inputFormDataDefault,
    number: inputFormDataDefault,
    reference: inputFormDataDefault,
    complement: inputFormDataDefault,
    district: inputFormDataDefault,
    city: inputFormDataDefault,
    state: inputFormDataDefault,
    zipCode: inputFormDataDefault,
};

const fetchCep = async (cep, config) => {
    const response = await SpotltmClient.get(
        `/cloudloyalty/v1/addresses/${cep}`,
        {
            headers: config,
        }
    );

    return response
}

const buildPhone = (phone, type) => {
    if (!phone) {
        return { areaCode: '', number: '', type };
    }

    const onlyNumbers = getOnlyNumbers(phone);
    return {
        areaCode: onlyNumbers.substr(0, 2),
        number: onlyNumbers.substr(2),
        type,
    };
};

let balloonSuccessRedemption = false
const PopBalloonFormToUpdateAddress = ({ callback, cancel }) => {
    const isMobile = useMediaQuery({ maxWidth: 768 })
    const Participants = useSelector(({ Participants: data }) => data);
    const userInfos = useSelector(({ oidc: data }) => data);
    const [blockEdition, setBlockEdition] = useState(false)
    const userProfile = useSelector((state) => state.oidc.user.profile);
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)
    const { setLoading: setPlaceholder } = usePlaceholderLoading()
    const [loadingIE, setLoadingIE] = useState(false)
    const {
        user: { profile, access_token },
    } = userInfos;
    const [defineForm, setDefineForm] = useState(false)
    const [formAddressData, setFormAddressData] = useState(initFormAddress)
    const [numberAddressAllow, setNumberAddressAllow] = useState(true)
    const [useform] = Form.useForm()
    const username = profile.username || profile['custom:login'];
    const { callApi } = usePipeContext();
    const config = {
        campaignId: userProfile['custom:campaign_id'],
        catalogId: userProfile['custom:catalog_id'],
        participantId: userProfile['custom:participant_id'],
        Authorization: `Bearer ${access_token}`,
        username: username,
    };
    const dispatch = useDispatch()



    const location = useLocation()

    useEffect(() => {
        if (balloonSuccessRedemption) balloonSuccessRedemption = false
    }, [location]);

    const setIeByUf = useCallback((uf) => {
        if (!uf) return;
        setLoadingIE(true)
        ValidateIe(userInfos, Participants.cpfCnpj.value, uf).then(({ data: { data } }) => {
            useform.setFieldValue('ie', data.ie || undefined)
        }).catch(() => {
            useform.setFieldValue('ie', undefined)

        }).finally(() => {
            setLoadingIE(false)
        })
    }, [userInfos, Participants])

    const handleCep = (cep) => {
        setBlockEdition(true)
        setError(null)
        fetchCep(cep, config).then(({ data }) => {
            useform.setFieldsValue({
                street: data.street,
                number: '',
                reference: '',
                complement: '',
                district: data.district,
                city: data.city,
                state: data.state
            })



            setIeByUf(data.state)


            setNumberAddressAllow(true)
        }).catch((e) => {
            setError(e.response.data?.errors[0]?.message || 'Ops! Tivemos um problema, por favor tente novamente mais tarde!')
        }).finally(() => {
            setBlockEdition(false)
        })
    }

    const handleCepDebounced = debounce(handleCep, 500)
    const handleCheckIE = debounce(setIeByUf, 1000)

    const fetchData = (symbol, payload = null, callback) => {
        const alias = generateUUID();
        callApi({
            symbol,
            alias,
            payload,
        }, undefined, callback);
    };

    const saveChange = () => {
        if (balloonSuccessRedemption) return;
        setIsLoading(true);
        const {
            birthDate,
            companyName,
            documentNumber,
            email,
            partnerCpf,
            name,
            phone,
            stateInscription,
            maritalStatus,
        } = {
            name: Participants.name,
            companyName: Participants.companyName,
            documentNumber: Participants.cpfCnpj,
            maritalStatus: Participants.maritalStatus,
            genderType: Participants.genderType,
            birthDate: Participants.birthDate,
            email: Participants.email,
            phone: {
                value: `${Participants.phones.mobile.areaCode}${Participants.phones.mobile.number}`,
                disabled: Participants.phones.mobile.disabled,
            },
            stateInscription: Participants.ie || 'ISENTO',
            partnerCpf: Participants.partnerCpf,
        };
        const { profileId, statusId, phonesDefault, emailsDefault } = Participants;

        let arrayEmail = emailsDefault;
        let emailCurrent = arrayEmail.some(
            (item) => item.email === email.value && item.type === 'PERSONAL'
        );
        if (!emailCurrent) {
            arrayEmail = arrayEmail.filter((item) => item.type !== 'PERSONAL');
            arrayEmail.push({ email: email.value, type: 'PERSONAL' });
        }

        let arrayPhone = phonesDefault;
        let phoneCurrent = arrayPhone.some(
            (item) =>
                `${item.areaCode}${item.number}` === phone.value &&
                item.type === 'MOBILE'
        );
        if (!phoneCurrent) {
            arrayPhone = [];
            arrayPhone.push(buildPhone(phone.value, 'MOBILE'));
            arrayPhone.push(buildPhone(phone.value, 'HOME'));
            arrayPhone.push(buildPhone(phone.value, 'WORK'));
        }

        const formAddress = useform.getFieldsValue()

        const addressData = {
            street: formAddress.street,
            number: (numberAddressAllow) ? formAddress.number : 'S/N',
            complement: formAddress.complement
                ? formAddress.complement
                : 'Nenhum',
            district: formAddress.district,
            city: formAddress.city,
            state: formAddress.state ? formAddress.state : 'SP',
            zipCode: getOnlyNumbers(useform.getFieldsValue().zipCode)
                ? getOnlyNumbers(useform.getFieldsValue().zipCode)
                : '00000000',
            reference: 'Nenhum',
        };

        let payloadData = {};
        if (Participants.personType === 1) {
            payloadData = {
                birthDate: moment(birthDate.value, 'DD/MM/YYYY').format(),
                documentNumber: getOnlyNumbers(documentNumber.value),
                emails: arrayEmail,
                genderType: genderTypes[3],
                maritalStatus: maritalStatus.value,
                name: name.value,
                phones: arrayPhone,
                profileId,
                stateInscription: useform.getFieldValue('ie') || 'ISENTO',
                status: profileStatuses[statusId],
                personType: 'INDIVIDUAL',
            };
        } else {
            let invalidBirthDate =
                birthDate.value === '' ||
                birthDate.value === undefined ||
                birthDate.value === null;

            const getBirthDate = () => {
                if (invalidBirthDate) return null;
                if (typeof invalidBirthDate === 'string' && /([0-9]){2}(\/)([0-9]){2}(\/)([0-9]){4}/.test(birthDate.value)) return birthDate.value
                return moment(birthDate.value, 'DD/MM/YYYY').format()
            }

            payloadData = {
                birthDate: getBirthDate(),
                companyName: companyName.value,
                documentNumber: getOnlyNumbers(documentNumber.value),
                emails: arrayEmail,
                genderType: genderTypes[3],
                maritalStatus: maritalStatus.value,
                name: name.value,
                partnerCpf: (partnerCpf.value) ? getOnlyNumbers(partnerCpf.value) : null,
                phones: arrayPhone,
                profileId,
                stateInscription: useform.getFieldValue('ie') || 'ISENTO',
                status: profileStatuses[statusId],
                personType: 'COMPANY',
            };
        }

        if (balloonSuccessRedemption) return;
        setPlaceholder(true)
        dispatch(closeBalloon())
        cancel()

        async function fetchDataAndUpdateParticipant() {
            try {
                fetchData('UPDATE_PARTICIPANT', {
                    ...payloadData,
                    address: addressData,
                });

                if (!balloonSuccessRedemption) {
                    fetchData('UPDATE_CART_SHIPPING', {
                        customer: { ...payloadData, email: Participants.email.value },
                        shippingAddress: addressData,
                    });
                }

                fetchData('FETCH_PARTICIPANT', null);
                fetchData('FETCH_CART', null);
                fetchData('FETCH_ORDERS_LIST', { offset: 0, limit: 5 });

                callback();
            } catch (error) {
                console.error('Ocorreu um erro:', error);
            }
        }

        fetchDataAndUpdateParticipant();

    }

    useEffect(() => {
        if (useform && defineForm) {
            useform.setFieldsValue({
                name: undefined,
                street: undefined,
                number: undefined,
                reference: undefined,
                complement: undefined,
                district: undefined,
                city: undefined,
                state: undefined,
                zipCode: undefined,
                ie: undefined
            })

            setDefineForm(true)
        }
    }, [useform, defineForm]);

    useEffect(() => {
        if (Participants && !balloonSuccessRedemption) {
            const addressData = handleObjectAddress({}, Participants);
            setFormAddressData(addressData);
        }
    }, [Participants])

    useEffect(() => {
        if (isLoading) return;
        useform.setFieldsValue({
            name: formAddressData.name.value,
            street: formAddressData.street.value,
            number: formAddressData.number.value,
            reference: formAddressData.reference.value,
            complement: formAddressData.complement.value,
            district: formAddressData.district.value,
            city: formAddressData.city.value,
            state: formAddressData.state.value,
            zipCode: formAddressData.zipCode.value,
            ie: undefined,
        })





        setIeByUf(formAddressData.state.value);

    }, [formAddressData, isLoading]);

    useEffect(() => {
        if (!numberAddressAllow && useform) {
            const address = useform.getFieldsValue()
            useform.setFieldsValue({
                ...address,
                number: ''
            })
        } else if (useform && !useform.getFieldsValue().number) {
            const address = useform.getFieldsValue()
            useform.setFieldsValue({
                ...address,
                number: formAddressData.number.value
            })
        }
    }, [useform, numberAddressAllow, formAddressData]);

    return (
        <>
            <section className={'PopBalloomAddressFromContainer'}>
                <div className={'PopBalloomAddressContent padding-y-small padding-x-regular'}>
                    <Row justify={'end'}>
                        <VertButton
                            type={'link'}
                            size={'small'}
                            className={'padding-y-none padding-x-small'}
                            onClick={() => {
                                if (cancel) cancel(),
                                    dispatch(closeModal())
                            }}
                        >
                            <span className={'color-neutral-dark-darker'}>
                                <CloseOutlined />
                            </span>
                        </VertButton>
                    </Row>
                    <header className={'padding-bottom-extra-small'}>
                        <VertTypography.Title level={1}>
                            Onde deseja receber o seu prêmio?
                        </VertTypography.Title>
                        <VertTypography.Paragraph>
                            Agora, para darmos continuidade ao processo, confirme seu endereço.
                        </VertTypography.Paragraph>
                        {error && (
                            <div
                                className={'padding-top-small'}
                            >
                                <VertAlert
                                    type={'error'}
                                    message={error}
                                    closable={false}
                                />
                            </div>
                        )}
                    </header>
                    <Form
                        id={'form-address'}
                        form={useform}
                        onFinish={(values) => {
                            const address = useform.getFieldsValue()

                            if (!/^(S\/N|\d+)$/.test(address.number)) {
                                useform.setFields([{
                                    name: 'number',
                                    errors: ['Somente números ou S/N.'],
                                }])
                                return;
                            }



                            const errors = useform.getFieldsError().filter(({ errors }) => errors.length > 0)
                            if (errors.length === 0) {

                                saveChange();
                            }
                        }}
                    >
                        <section className={'padding-top-small'}>
                            <Row justify={'start'} align={'middle'}>
                                <Col span={(isMobile) ? 24 : 10}>
                                    <Form.Item
                                        name={'zipCode'}
                                    >
                                        <MaskedInput

                                            label={"CEP"}
                                            mask={'99999-999'}
                                            disabled={loadingIE || isLoading || isLoading || formAddressData.zipCode.disabled}
                                            onChange={(e) => {
                                                if (e !== '' && e.length === 8) {
                                                    handleCepDebounced(e)
                                                } else {
                                                    setBlockEdition(true)
                                                }
                                            }}
                                        />
                                    </Form.Item>
                                </Col>


                                <Col span={(isMobile) ? 24 : 14}>
                                    <Form.Item
                                        name={'ie'}

                                    >
                                        <VertInput
                                            label={"Incrição Estadual"}
                                            disabled={loadingIE || isLoading || isLoading || formAddressData.zipCode.disabled}
                                            onChange={() => {
                                                const state = useform.getFieldValue('state')
                                                if (state) {
                                                    handleCheckIE(state)
                                                }
                                            }}
                                        />
                                    </Form.Item>
                                </Col>


                            </Row>
                        </section>


                        <section className={'padding-bottom-small'}>
                            <Row justify={'start'} align={'middle'}>
                                <Col span={19}>
                                    <Form.Item
                                        name={'street'}
                                        rules={[
                                            { required: true, message: 'O Endereço precisa ser preenchido.' },
                                        ]}
                                    >
                                        <VertInput
                                            disabled={loadingIE || isLoading || formAddressData.street.disabled || blockEdition}
                                            label={"Endereço"}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={(isMobile) ? 24 : 5}>
                                    <Form.Item
                                        name={'state'}
                                        rules={[
                                            { required: true, message: 'A UF precisa ser preenchida.' },
                                        ]}
                                    >
                                        <VertSelect
                                            items={listUF}
                                            disabled={loadingIE || isLoading || formAddressData.state.disabled || blockEdition}
                                            showSearch
                                            label="UF"
                                            placeholder=""
                                            template="marketplace"
                                            onChange={(e) => {
                                                setIeByUf(e)
                                            }}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row justify={'start'} align={'middle'}>
                                <Col span={(isMobile) ? 16 : 8}>
                                    <Form.Item
                                        name={'number'}
                                        rules={[
                                            { required: numberAddressAllow, message: 'O Número precisa ser preenchido.' },
                                        ]}
                                    >
                                        <VertInput
                                            disabled={loadingIE || isLoading || formAddressData.number.disabled || !numberAddressAllow || blockEdition}
                                            label={"Número"}
                                        />
                                    </Form.Item>
                                    <MediaQuery maxWidth={768}>
                                        <Col span={24}>
                                            <VertCheckbox
                                                checked={!numberAddressAllow}
                                                className="margin-bottom-extra-small margin-top-none"
                                                onClick={() => {
                                                    setNumberAddressAllow(!numberAddressAllow)
                                                }}
                                            >
                                                Sem número
                                            </VertCheckbox>
                                        </Col>
                                    </MediaQuery>
                                </Col>
                                <Col span={(isMobile) ? 24 : 16}>
                                    <Form.Item
                                        name={'complement'}
                                        rules={[
                                            { max: 20, message: 'Complemento deve ter no máximo 20 caracteres.' }
                                        ]}
                                    >
                                        <VertInput
                                            disabled={loadingIE || isLoading || formAddressData.complement.disabled || blockEdition}
                                            label={"Complemento"}
                                            maxLength={20}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <MediaQuery minWidth={768}>
                                <Row>
                                    <Col span={24}>
                                        <VertCheckbox
                                            checked={!numberAddressAllow}
                                            className="margin-bottom-extra-small margin-top-none"
                                            onClick={() => {
                                                setNumberAddressAllow(!numberAddressAllow)
                                            }}
                                        >
                                            Sem número
                                        </VertCheckbox>
                                    </Col>
                                </Row>
                            </MediaQuery>
                            <Row justify={'start'} align={'middle'}>
                                <Col span={(isMobile) ? 24 : 12}>
                                    <Form.Item
                                        name={'district'}
                                        rules={[
                                            { required: true, message: 'O Bairro precisa ser preenchido.' },
                                            { max: 20, message: 'Bairro deve ter no máximo 20 caracteres.' },
                                        ]}
                                    >
                                        <VertInput
                                            disabled={loadingIE || isLoading || formAddressData.district.disabled || blockEdition}
                                            label={"Bairro"}
                                            maxLength={20}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={(isMobile) ? 24 : 12}>
                                    <Form.Item
                                        name={'city'}
                                        rules={[
                                            { required: true, message: 'O Estado precisa ser preenchido.' },
                                        ]}
                                    >
                                        <VertInput
                                            disabled={loadingIE || isLoading || formAddressData.city.disabled || blockEdition}
                                            label={"Cidade"}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row justify={'start'} align={'middle'}>
                                <Col span={24}>
                                    <VertButton
                                        type={'detached'}
                                        htmlType={'submit'}
                                        disabled={isLoading || blockEdition || loadingIE}
                                        className={(isMobile) ? 'w-full' : ''}
                                        loading={loadingIE}
                                        block
                                    >
                                        Finalizar resgate
                                    </VertButton>
                                </Col>
                            </Row>
                        </section>
                    </Form>
                </div>
            </section>
        </>
    )
}

PopBalloonFormToUpdateAddress.propTypes = {
    callback: PropTypes.func,
    cancel: PropTypes.func,
}

export default PopBalloonFormToUpdateAddress
